import axios from 'axios';

const apiCore = axios.create({
  baseURL: process.env.REACT_APP_WP_HOST + '/wp-json/wp/v2',
});

export default apiCore;
